import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Values.css";

export default function Values(props) {
  return (
    <div>
      <Container fluid className="values-fluid-container">
        <div
          style={{ background: props.fadeBG }}
          className="values-img-overlay"
        >
          <Container>
            <Row>
              <Col className="values-first-col">
                <h2 style={{ color: props.white, fontSize: props.titleSize }}>
                  NOSSOS VALORES
                </h2>
              </Col>
            </Row>
            <Row>
              <Col className="values-second-col">
                <p style={{ color: props.white, fontSize: props.textSize }}>
                  Essas são as diretrizes que norteiam nosso trabalho e
                  conquistam há mais de um século a confiança de milhares de
                  famílias.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
      <Container fluid>
        <Container className="values-container">
          <Row>
            <Col className="values-third-col">
              <div style={{ background: props.white }} className="values-card">
                <div className="values-icon-humanizacao" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  Humanização
                </h3>
              </div>
            </Col>
            <Col className="values-third-col">
              <div style={{ background: props.white }} className="values-card">
                <div className="values-icon-etica" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  Ética
                </h3>
              </div>
            </Col>
            <Col className="values-third-col">
              <div style={{ background: props.white }} className="values-card">
                <div className="values-icon-excelencia" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  Excelência
                </h3>
              </div>
            </Col>
            <Col className="values-third-col">
              <div style={{ background: props.white }} className="values-card">
                <div className="values-icon-valorizacao" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  Valorização
                </h3>
              </div>
            </Col>
            <Col className="values-third-col">
              <div style={{ background: props.white }} className="values-card">
                <div className="values-icon-inovacao" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  Inovação
                </h3>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}
